import React, {useEffect, useState} from 'react';
import Navbar from "../components/base/Navbar";
import Contact from "../components/Contact";
import Footer from "../components/base/Footer";
import {getBlogs} from "../admin/services/BlogAPI";
import {useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHome} from "@fortawesome/fontawesome-free-solid";

const BlogPost = () => {
    const { id } = useParams();
    const [title, setTitle] = useState("");
    const [author, setAuthor] = useState("");
    const [content, setContent] = useState("");
    const [createdAt, setCreatedAt] = useState(null);

    useEffect(() => {
        if (id) {
            getBlogs().then((response) => {
                const blog = response.data.find((b) => b.id === parseInt(id));
                if (blog) {
                    setTitle(blog.title);
                    setAuthor(blog.author);
                    setContent(blog.content);
                    setCreatedAt(blog.createdAt)
                }
            });
        }
    }, [id]);

    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric'};
        return new Date(date).toLocaleDateString('de-DE', options);
    };

    const formatContent = (text) => {
        return text.split("\n").map((line, index) => (
            <p key={index} className="mb-2">{line}</p>
        ));
    };


    return (
        <div className="bg-gray-200 pt-24 bg-center">

            <Navbar/>

            <div className="w-full m-12"></div>

            <div className="md:inline text-center">
                <div className="my-4 text-center md:ml-48 md:text-left">
                    <h1 className="lg:text-6xl text-4xl inline-block font-bold drop-shadow-md bg-gradient-to-r from-gray-800 to-gray-500 text-transparent bg-clip-text">{title}</h1>
                </div>

                <div className="w-full lg:w-1/4 inline-flex justify-center my-4 m-auto md:ml-48 lg:text-left gap-2">
                    <p className="text-2xl text-gray-700 font-bold">{author}</p>
                    <p className="text-2xl text-gray-700">{formatDate(createdAt)}</p>
                </div>

                <a href="/blogs" className="lg:absolute lg:right-48 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                    <FontAwesomeIcon icon={faHome} className="fill-current w-4 h-4 mr-2 "/>
                    <span>Zurück</span>
                </a>
            </div>



            <div className="w-full m-12"></div>

            <span className="lg:w-1/2 w-3/4 mx-auto block text-gray-800 text-center">
                <div className="container block w-full m-auto">
                    <p className="w-full mx-auto block text-left">
                    {formatContent(content)}
                </p>
                </div>
            </span>

            <div className="w-full m-12"></div>

            <div className="bg-gray-100/50 bg-border h-[5px]"></div>

            <div className="w-full m-12"></div>

            <Contact/>

            <div className="w-full m-12"></div>

            <Footer/>
        </div>
    )
}

export default BlogPost;